<template>
  <base-layout-without-logo :menu-items="menuItems">
    <template slot="content">
      <!-- Loader -->
      <div class="absolute bg-grey-100 bg-opacity-50 h-full left-0 top-0 w-full z-99" v-if="getIsLoading">
        <gd-loader :label="$t('frontend_loading')"/>
      </div>

      <!-- target for other loders -->
      <portal-target name="loaderTarget"></portal-target>

      <!-- target for modals -->
      <portal-target name="modalsTarget"></portal-target>
      
      <div id="groovesellCont" class="w-full h-full flex">
        <VuePerfectScrollbar
          class="w-full h-full"
          :settings="scrollbarSettings"
        >
          <transition :name="routerTransition">
            <router-view></router-view>
          </transition>
        </VuePerfectScrollbar>
      </div>
    </template>
    <template slot="header-bar">
      <header-bar
        v-if="$route.meta.breadcrumb || $route.meta.pageTitle"
        :route-title="$t(routeTitle)"
      ></header-bar>
    </template>
  </base-layout-without-logo>
</template>

<script>
import axios from 'axios';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import { mapGetters, mapMutations } from 'vuex';
import store from '@/state';
import BaseLayoutWithoutLogo from '../components/BaseLayoutWithoutLogo';

export default {
  components: {
    BaseLayoutWithoutLogo,
    VuePerfectScrollbar,
  },
  data() {
    return {
      isExternal: true,
      showSlider: false,
      routerTransition: 'zoom-fade',
      routeTitle: this.$route.meta.pageTitle,
      isAdmin: null,
      scrollbarSettings: {
        maxScrollbarLength: 60,
      },
    };
  },
  computed: {
    ...mapGetters('loader', ['getIsLoading']),

    menuItems() {
      return [];
    },
  },

  watch: {
    $route() {
      this.routeTitle = this.$route.meta.pageTitle;
    },
  },
  async created() {
    this.isAdmin = store.state.user.admin;
    const dashboardData = await axios.get('/dashboard');
    this.SET_CAN_MAIL(dashboardData.data.can_mail);
    this.SET_CAN_IMPORT_LEADS(dashboardData.data.can_import);
    this.SET_CAN_ACCESS_INTERNAL_SMTP(dashboardData.data.groovemail_smtp_enable);
  },

  methods: {
    ...mapGetters('mailing', ['getCanMail']),
    ...mapMutations('mailing', ['SET_CAN_MAIL', 'SET_CAN_IMPORT_LEADS', 'SET_CAN_ACCESS_INTERNAL_SMTP']),

    changeRouteTitle(title) {
      this.routeTitle = title;
    },
  },
};
</script>

<style scoped>
#groovesellCont {
  height: calc(100vh - 4rem) !important;
}
</style>
